import React, { useEffect, useState, useRef } from "react"; // Import useRef

import { useDispatch } from "react-redux";
import {
  createFormInstance,
  getFormById,
} from "../../../redux/slices/forms.slice";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  // Select,
  TextField,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  checkEmailDuplicate,
  getAllProject,
  ProjectLocationAutoCompleteSuggesstionThunk,
  updateUserThunk,
} from "../../../redux/slices/tenant.slice";

import { setSnackbar } from "../../../redux/slices/common.slice";
import DeleteIcon from "@mui/icons-material/Delete";

import "../../../styles/forms.css";
import { getAllServiceUnit } from "../../../redux/slices/serviceUnit.slice";
import Select from "react-select";

import { AddCircleOutline, PhotoCamera } from "@mui/icons-material";
import CustomizedDialog from "../Dialog";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import logAnalyticsEvent from "../../../firebase/analyticsLogger";
import ReactQuill from "react-quill";
import { modules } from "../../../utils/icon/CommonFunctions";
import Loader from "../Loader";
import SignatureCanvas from "react-signature-canvas";
import CancelIcon from "@mui/icons-material/Cancel";

const customStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #ced4da",
    borderRadius: "4px",

    minHeight: "40px", // Mimicking MUI's small size
  }),
  menu: (provided) => ({
    ...provided,

    maxHeight: "168px",
    overflowY: "auto",
  }),
  menuList: (provided) => ({
    ...provided,

    maxHeight: "168px", // Sets a max height for the menu items list
    overflowY: "auto", // Ensures the list itself is scrollable
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "rgba(25, 118, 210, 0.08)" // Highlight selected item with color
      : state.isFocused
      ? "#fafafa" // Hover effect
      : "white",
    color: "black",
    "&:active": {
      backgroundColor: "rgba(25, 118, 210, 0.08)",
    },
  }),
};

export default function CreateFormModal({
  isOpenDrawer,
  setIsOpenDrawer,
  serviceUnitId = null,
  taskId,
  templateId,
  empId = null,
  fetchAllTasks = () => {},
  prefillData,
  title = "Start Inspection",
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [formSections, setFormSections] = useState([]);

  const [locationOption, setLocationOption] = useState([]);

  const [errors, setErrors] = useState({}); // State to manage validation errors

  const formRef = useRef(null);

  const [imageData, setImageData] = useState({});
  const [selectedUsers, setSelectedUsers] = useState();
  const users = useSelector((state) => state.common.users);
  const [serviceUnitOptions, setServiceUnitOptions] = useState();
  const [serviceUnit, setServiceUnit] = useState();
  const [projectOptions, setProjectOptions] = useState();
  const [project, setProject] = useState();
  const [formType, setFormType] = useState();
  const [selectedUser, setSelectedUser] = useState();

  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [userData, setUserData] = useState();

  const [owners, setOwners] = useState([]);
  const [site, setSite] = useState();
  const signaturePadRef = useRef(null); // Reference for the SignatureCanvas

  const user = useSelector((state) => state.user);
  const [notes, setNotes] = useState({});

  const navigate = useNavigate();
  useEffect(() => {
    if (empId) {
      const tempUser = users.find((user) => +user.value === +empId);

      if (tempUser) {
        setSelectedUser(tempUser);
      }
    }
  }, [empId]);

  useEffect(() => {
    if (prefillData) setImageData(prefillData);
  }, [prefillData]);
  const handleCloseDrawer = () => {
    setIsOpenDrawer(false);
    setImageData({});
    // setServiceUnit();
  };

  const handleClearSignature = () => {
    if (signaturePadRef.current) signaturePadRef.current.clear(); // Clear the signature pad
  };
  const arr = [
    {
      id: "s-1",
      name: "General Details",
      questions: [
        {
          id: "q-s-1-1",
          label: "Title",
          options: [],
          required: true,
          type: "Text Field",
          width: 6,
        },
        {
          id: "q-s-1-2",
          type: "Text Field",
          label: "Description",
          options: [],
          required: true,
          width: 12,
        },
        {
          id: "q-s-1-5",
          label: "Upload Image(s)",
          options: [],
          required: false,
          type: "Media",
          width: 12,
        },
        {
          id: "q-s-1-6",
          label: "Upload Video(s)",
          options: [],
          required: false,
          type: "Video",
          width: 12,
        },
      ],
    },
    {
      id: "s-2",
      name: "Audit Details",
      questions: [
        {
          id: "q-s-2-1",
          label: "What is the Risk Identified",
          options: [],
          required: false,
          type: "Text Field",
          width: 12,
        },
        {
          id: "q-s-2-2",
          type: "Text Field",
          label: "Description of Risk",
          options: [],
          required: false,
          width: 12,
        },
        {
          id: "q-s-2-3",
          type: "Text Field",
          label: "Impact on Project",
          options: [],
          required: false,
          width: 12,
        },
        {
          id: "q-s-2-4",
          type: "Radio Buttons",
          label: "How likely is it for the incident to happen again?",
          options: ["Low", "Medium", "High", "N/A"],
          required: false,
          width: 12,
        },
        {
          id: "q-s-2-5",
          type: "Radio Buttons",
          label: "What is the level of seriousness?",
          options: ["Low", "Medium", "High", "Extreme"],
          required: false,
          width: 12,
        },
        {
          id: "q-s-2-6",
          type: "Radio Buttons",
          label: "Change in risk since last audit",
          options: ["New Risk", "No Change", "Decreased", "Increased"],
          required: false,
          width: 12,
        },
        {
          id: "q-s-2-7",
          type: "Text Field",
          label: "Mitigation actions",
          options: [],
          required: false,
          width: 12,
        },
        {
          id: "q-s-2-8",
          type: "Text Field",
          label: "Task",
          options: [],
          required: false,
          width: 6,
        },
        {
          id: "q-s-2-9",
          type: "Number",
          label: "Cost",
          options: [],
          required: false,
          width: 6,
        },
        {
          id: "q-s-2-10",
          type: "CheckBox",
          label: "Project manager signoff",
          options: [],
          required: false,
          width: 12,
        },
      ],
    },
  ];
  const fetchAllserviceUnit = async () => {
    // setLoading(true);

    try {
      let response = await dispatch(
        getAllServiceUnit({
          page_number: 1,
        })
      );
      const { payload } = response;
      if (payload?.status) {
        setServiceUnitOptions(
          payload?.data?.map((item, idx) => ({
            label: item.name,
            value: item.id,
          }))
        );
        if (serviceUnitId) {
          const temp = payload?.data?.find(
            (item, idx) => item.id === +serviceUnitId
          );
          if (temp) {
            setServiceUnit({
              label: temp.name,
              value: temp.id,
            });
            setOwners(temp?.owners);
            setSite(temp?.project);
          }
        }
      } else {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: payload?.message || "Internal server error",
          })
        );
      }
    } catch (error) {
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: "Internal server error",
        })
      );
    }

    // setLoading(false);
  };
  useEffect(() => {
    fetchAllserviceUnit();
  }, []);

  const fetchAllProject = async () => {
    setLoading(true);
    // const networkTrace = trace(performance, "load_projects");
    // networkTrace.start(); // Start the trace
    try {
      let response = await dispatch(
        getAllProject({
          page_number: 1,
          page_size: 100000,
        })
      );
      const { payload } = response;
      if (payload?.status) {
        setProjectOptions(
          payload?.data?.map((item, idx) => ({
            label: item.name,
            value: item.id,
          }))
        );
      } else
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: payload?.message || "Internal server error",
          })
        );
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllProject();
  }, []);

  const fetchFormById = async () => {
    setLoading(true);
    try {
      const response = await dispatch(getFormById({ formId: templateId }));
      const { payload } = response;
      if (payload?.status) {
        setFormSections(payload?.data?.form_struct_json);
        setFormType(payload?.data?.type);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (templateId) fetchFormById();
    else setLoading(false);
  }, [templateId, isOpenDrawer]);

  let timeOut = null;
  const handleAutocompleteChange = (event, values) => {
    if (values !== "") {
      if (timeOut) clearTimeout(timeOut);

      timeOut = setTimeout(async () => {
        try {
          const response = await ProjectLocationAutoCompleteSuggesstionThunk({
            location: values,
          });
          const suggestionList = response.data; // Adjust this based on the structure of your response
          let temp = [];
          suggestionList?.predictions?.map((element) => {
            temp.push({
              label: element?.description,
              value: element?.place_id,
            });
          });
          setLocationOption(temp);
        } catch (error) {}
      }, 500);
    }
  };

  const validateForm = (formData) => {
    const newErrors = {};
    if (!selectedUser && formType === "work_permit")
      newErrors["user"] = "Required";
    if (!selectedUser && (formType === "inspection" || formType === "audit"))
      newErrors["user"] = "Required";
    if (
      !(signaturePadRef.current && !signaturePadRef.current.isEmpty()) &&
      (formType === "inspection" || formType === "audit")
    )
      newErrors["signature"] = "Required";

    formSections.forEach((section) => {
      section.questions.forEach((question) => {
        const value = formData[question.id];
        if (question.label === "Email") {
          // Check here for email validation
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Simple email regex
          if (!emailRegex.test(value)) {
            newErrors[question.id] = `Invalid Email Format`;
          }
        }
        // Only validate required questions
        if (question.required) {
          if (question.type === "CheckBox") {
            // Checkbox can be unchecked, handle accor dingly
            if (!value) {
              newErrors[question.id] = `Required`;
            }
          } else if (question.type === "Media") {
            if (
              !imageData[question.label] || // Check if it's null, undefined, or an empty object
              (Array.isArray(imageData[question.label]) &&
                imageData[question.label].length === 0) // Check if it's an empty array
            ) {
              newErrors[question.id] = `Required`; // Add an error if validation fails
            }
          } else if (question.type === "Video") {
            if (
              !imageData[question.label] || // Check if it's null, undefined, or an empty object
              (Array.isArray(imageData[question.label]) &&
                imageData[question.label].length === 0) // Check if it's an empty array
            ) {
              newErrors[question.id] = `Required`; // Add an error if validation fails
            }
          } else if (question.type === "Users") {
            if (!selectedUsers) {
              newErrors[question.id] = `Required`; // Add an error if validation fails
            }
          } else if (!value) {
            newErrors[question.id] = `Required`;
          }
        }
      });
    });
    setErrors(newErrors);
    scrollToError(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if there are no errors
  };
  function removeUntilFirstComma(str) {
    const commaIndex = str.indexOf(",");
    if (commaIndex !== -1) {
      return str.substring(commaIndex + 1); // +1 to skip the comma itself
    }
    return str; // return original string if no comma is found
  }

  const checkEmailExists = async (email) => {
    try {
      const response = await dispatch(checkEmailDuplicate({ email }));
      const { payload } = response;
      if (payload?.status) {
        if (payload?.user_exists) {
          setUserData(payload?.data);
          setOpenEmailModal(true);
          // handleCloseDrawer();

          return true;
        } else {
          return false;
        }
      } else {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: payload?.message || "Internal server error",
          })
        );
        return false;
      }
    } catch (error) {
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: "Internal server error",
        })
      );
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formElement = formRef.current;
    let data = new FormData(formElement);
    const formData = Object.fromEntries(data);
    console.log(formData);

    if (!validateForm(formData)) {
      return;
    }

    if (formType === "employee_induction") {
      let shouldReturn = false;

      for (const section of formSections) {
        for (const question of section.questions) {
          if (question.label === "Email") {
            const emailExists = await checkEmailExists(formData[question.id]);
            if (emailExists) {
              shouldReturn = true; // Set the flag to true if the condition is met
              return; // Exit the function completely
            }
          }
        }
      }

      // If the flag is set, return completely from the function
      if (shouldReturn) return;
    }
    let signature;
    if (signaturePadRef && signaturePadRef.current) {
      signature = signaturePadRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
    }
    setSubmitLoading(true);
    const finalData = {
      form: +templateId,
      task: taskId ? +taskId : undefined,
      service_unit: serviceUnit?.value,
      user: selectedUser ? selectedUser.value : undefined,
      auditor: selectedUser ? selectedUser.value : undefined,
      auditor_sign: signature // Get signature as a base64 string
        ? {
            base: removeUntilFirstComma(signature),
            extension: signature.substring(
              signature.indexOf("/") + 1,
              signature.indexOf(";")
            ),
          }
        : undefined,
      submission_json: formSections.map((section) => {
        return {
          section: section.id,
          section_name: section.name,
          questions: section.questions.map((question) => {
            let isSelected = null;
            let groupValue = null;
            let images = null;
            let videos = null;
            let answer = "";
            let users = null;

            if (question.type === "CheckBox") {
              isSelected = formData[question.id] === "true";
            } else if (question.type === "Radio Buttons") {
              groupValue = formData[`${question.id}`] || null;
            } else if (question.type === "Media") {
              images =
                imageData[question.label]?.map((item) => {
                  return {
                    base: removeUntilFirstComma(item.base64) || "", // Fallback if undefined
                    extension: item.extension || "", // Fallback if undefined
                  };
                }) || [];
            } else if (question.type === "Video") {
              videos =
                imageData[question.label]?.map((item) => {
                  return {
                    base: removeUntilFirstComma(item.base64) || "", // Fallback if undefined
                    extension: item.extension || "", // Fallback if undefined
                  };
                }) || [];
            } else if (question.type === "Users") {
              users = selectedUsers?.map((item) => item.value) || [];
            } else {
              answer = formData[question.id] || null;
            }

            return {
              question_id: question.id,
              answer: answer,
              answer_type: question.type,
              group_value: groupValue,
              is_selected: isSelected,
              required: question.required,
              images: images,
              videos: videos,
              label: question.label,
              width: question.width,
              options: question.options,
              users: users,
              others: notes[question.id] || null,
            };
          }),
        };
      }),
    };

    try {
      let response = await dispatch(
        createFormInstance({
          formData: finalData,
        })
      );
      const { payload } = response;
      if (payload && payload.status) {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "success",
            message: "Form Submitted Succesfully.",
          })
        );
        logAnalyticsEvent("create_form_submission", {
          user_id: user?.data?.user?.id,
        });
        handleCloseDrawer();
        fetchAllTasks();
      } else {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: payload.message || "Internal server error",
          })
        );
      }
    } catch (error) {
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: error || "Internal server error",
        })
      );
    }
    setSubmitLoading(false);
  };

  const scrollToError = (errors) => {
    const errorField = Object.keys(errors)[0]; // Get the first error field

    const errorElement = document.getElementById(errorField); // Find the DOM element of that field
    if (errorElement) {
      errorElement.scrollIntoView({ behavior: "smooth", block: "center" }); // Scroll to the error field
    }
  };

  const ChangeUserStatus = async () => {
    try {
      let response = await dispatch(
        updateUserThunk({
          id: userData?.id,
          data: { ...userData, is_active: true },
        })
      );
      const { payload } = response;
      if (payload && payload.status) {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "success",
            message: "User Status Changed Succesfully.",
          })
        );
        handleCloseDrawer();
        setOpenEmailModal(false);
        navigate(`/employee/${userData?.id}/view`);
      } else {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: payload.message || "Internal server error",
          })
        );
      }
    } catch (error) {
      await dispatch(
        setSnackbar({
          open: true,
          severity: "error",
          message: error || "Internal server error",
        })
      );
    }
  };

  return (
    <>
      {submitLoading && <Loader />}
      <CustomizedDialog
        className="modal-scroll popup"
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        // slots={{ backdrop: Backdrop }}
        title={title}
        open={isOpenDrawer}
        handleClose={() => {
          handleCloseDrawer();
        }}
      >
        <DialogContent>
          {loading ? (
            <Box
              sx={{
                margin: "auto",
                height: "500px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
              {formType === "work_permit" && (
                <>
                  <Typography variant="body1" component="label">
                    Select User
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <Select
                    options={users}
                    value={selectedUser}
                    onChange={(e) => {
                      setSelectedUser(e);
                      setErrors((prevErrors) => {
                        const newErrors = { ...prevErrors };
                        delete newErrors["user"];
                        return newErrors;
                      });
                    }}
                    menuPortalTarget={document.body}
                    styles={customStyles}
                    placeholder="Select Users"
                  />
                  {errors["user"] && (
                    <div className="form-error-message">{errors["user"]}</div>
                  )}
                  <br />
                </>
              )}

              {formType === "inspection" && (
                <Card
                  sx={{
                    padding: "16px",
                    marginBottom: "16px !important",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: "16px !important",
                          fontWeight: 500,
                        }}
                      >
                        <b> Equipment:</b> {serviceUnit?.label || "-"}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: "16px !important",
                          fontWeight: 500,
                        }}
                      >
                        <b> Site:</b> {site?.name || "-"}
                      </Typography>
                    </Grid>

                    {/* Owners Information */}
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        Owners:
                      </Typography>
                      <Grid container>
                        {owners?.length > 0 ? (
                          owners.map((item, index) => (
                            <Grid item xs={12} sm={6}>
                              <Typography
                                key={index}
                                variant="body2"
                                sx={{
                                  fontSize: "15px !important",
                                  lineHeight: "1.6",
                                  marginBottom: "8px",
                                  color: "#333",
                                }}
                              >
                                <span
                                  style={{ color: "#036185", fontWeight: 600 }}
                                >
                                  Name:{" "}
                                </span>
                                {item?.first_name + " " + item?.last_name}
                                <br />
                                <span
                                  style={{ color: "#036185", fontWeight: 600 }}
                                >
                                  Email:{" "}
                                </span>
                                {item?.email}
                              </Typography>
                            </Grid>
                          ))
                        ) : (
                          <Typography
                            variant="body2"
                            sx={{
                              fontSize: "15px !important",
                              fontStyle: "italic",
                              color: "#666",
                            }}
                          >
                            No owners available.
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              )}

              <form ref={formRef} onSubmit={handleSubmit}>
                {formSections &&
                  formSections.map((section) => (
                    <Accordion key={section.id} defaultExpanded={true}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon className="expand-icon" />}
                        className="accordion-summary-background accordion-summary-root"
                      >
                        <Typography className="accordion-summary-typography">
                          {section.name}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails className="accordion-details">
                        <Grid container spacing={3}>
                          {section.questions.map((question) => (
                            <Grid
                              item
                              lg={question.width}
                              xs={12}
                              key={question.id}
                            >
                              <Box>
                                <Typography variant="body1" component="label">
                                  {question?.label}
                                  {question.required && (
                                    <span style={{ color: "red" }}> *</span>
                                  )}
                                </Typography>

                                {question.type === "Text Field" && (
                                  <>
                                    <TextField
                                      fullWidth
                                      variant="outlined"
                                      placeholder="Your answer here"
                                      size="small"
                                      required={question.required}
                                      name={question.id}
                                      id={question.id}
                                      value={imageData[question.label] || ""}
                                      onChange={(e) => {
                                        const { name, value } = e.target; // Get the name and value of the input field
                                        // Update the errors state to remove the error for the current question
                                        setErrors((prevErrors) => {
                                          const newErrors = { ...prevErrors };
                                          delete newErrors[name];
                                          return newErrors;
                                        });
                                        setImageData((prevData) => {
                                          const newData = { ...prevData };
                                          newData[question.label] = value;
                                          return newData;
                                        });
                                      }}
                                      error={!!errors[question.id]}
                                    />
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                  </>
                                )}
                                {question.type === "Rich_TextBox" && (
                                  <>
                                    <Box className={"rich-editor"}>
                                      <ReactQuill
                                        theme="snow"
                                        value={imageData[question.label] || ""}
                                        modules={modules}
                                        name={question.id}
                                        id={question.id}
                                        required={question.required}
                                        onChange={(value) => {
                                          setErrors((prevErrors) => {
                                            const newErrors = { ...prevErrors };
                                            delete newErrors[question?.id];
                                            return newErrors;
                                          });
                                          setImageData((prevData) => {
                                            const newData = { ...prevData };
                                            newData[question.label] = value;
                                            return newData;
                                          });
                                        }}
                                        error={!!errors[question.id]}
                                      />
                                      <input
                                        type="hidden"
                                        name={question.id}
                                        value={imageData[question.label] || ""} // Sync with editor content
                                      />
                                    </Box>
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                  </>
                                )}
                                {question.type === "CheckBox" && (
                                  <>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name={question.id}
                                          id={question.id}
                                          value={imageData[question.label]}
                                          onChange={(e) => {
                                            const { name, checked } = e.target; // Get the name and value of the input field
                                            // Update the errors state to remove the error for the current question
                                            setErrors((prevErrors) => {
                                              const newErrors = {
                                                ...prevErrors,
                                              }; // Create a copy of the previous errors state
                                              delete newErrors[name]; // Remove the error for the specific question using its name
                                              return newErrors; // Return the updated errors object
                                            });

                                            setImageData((prevData) => {
                                              const newData = { ...prevData };
                                              newData[question.label] = checked;
                                              return newData;
                                            });
                                          }}
                                        />
                                      }
                                      sx={{ fontWeight: 600 }}
                                    />
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                  </>
                                )}
                                {question.type === "Number" && (
                                  <>
                                    <TextField
                                      type="number"
                                      fullWidth
                                      variant="outlined"
                                      placeholder="Enter a number"
                                      size="small"
                                      required={question.required}
                                      name={question.id}
                                      id={question.id}
                                      value={imageData[question.label] || ""}
                                      onChange={(e) => {
                                        const { name, value } = e.target; // Get the name and value of the input field
                                        // Update the errors state to remove the error for the current question
                                        setErrors((prevErrors) => {
                                          const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                          delete newErrors[name]; // Remove the error for the specific question using its name
                                          return newErrors; // Return the updated errors object
                                        });
                                        setImageData((prevData) => {
                                          const newData = { ...prevData };
                                          newData[question.label] = value;
                                          return newData;
                                        });
                                      }}
                                      error={!!errors[question.id]}
                                    />
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                  </>
                                )}
                                {question.type === "Date & Time" && (
                                  <>
                                    <TextField
                                      type="datetime-local"
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                      required={question.required}
                                      name={question.id}
                                      id={question.id}
                                      value={imageData[question.label] || ""}
                                      onChange={(e) => {
                                        const { name, value } = e.target; // Get the name and value of the input field
                                        // Update the errors state to remove the error for the current question
                                        setErrors((prevErrors) => {
                                          const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                          delete newErrors[name]; // Remove the error for the specific question using its name
                                          return newErrors; // Return the updated errors object
                                        });
                                        setImageData((prevData) => {
                                          const newData = { ...prevData };
                                          newData[question.label] = value;
                                          return newData;
                                        });
                                      }}
                                      error={!!errors[question.id]}
                                    />
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                  </>
                                )}
                                {question.type === "Time" && (
                                  <>
                                    <TextField
                                      type="time"
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                      required={question.required}
                                      name={question.id}
                                      id={question.id}
                                      value={imageData[question.label] || ""}
                                      onChange={(e) => {
                                        const { name, value } = e.target; // Get the name and value of the input field
                                        // Update the errors state to remove the error for the current question
                                        setErrors((prevErrors) => {
                                          const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                          delete newErrors[name]; // Remove the error for the specific question using its name
                                          return newErrors; // Return the updated errors object
                                        });
                                        setImageData((prevData) => {
                                          const newData = { ...prevData };
                                          newData[question.label] = value;
                                          return newData;
                                        });
                                      }}
                                      error={!!errors[question.id]}
                                    />
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                  </>
                                )}
                                {question.type === "Date" && (
                                  <>
                                    <TextField
                                      type="date"
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                      required={question.required}
                                      name={question.id}
                                      id={question.id}
                                      value={imageData[question?.label] || ""}
                                      onChange={(e) => {
                                        const { name, value } = e.target; // Get the name and value of the input field
                                        // Update the errors state to remove the error for the current question
                                        setErrors((prevErrors) => {
                                          const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                          delete newErrors[name]; // Remove the error for the specific question using its name
                                          return newErrors; // Return the updated errors object
                                        });
                                        setImageData((prevData) => {
                                          const newData = { ...prevData };
                                          newData[question.label] = value;
                                          return newData;
                                        });
                                      }}
                                      error={!!errors[question.id]}
                                    />
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                  </>
                                )}
                                {question.type === "Location" && (
                                  <>
                                    <Autocomplete
                                      className="project-location-autocomplete"
                                      freeSolo
                                      onInputChange={(event, values) => {
                                        handleAutocompleteChange(event, values);
                                      }}
                                      value={imageData[question.label] || ""}
                                      onChange={(e, value) => {
                                        const { name } = e.target; // Get the name and value of the input field
                                        // Update the errors state to remove the error for the current question
                                        setErrors((prevErrors) => {
                                          const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                          delete newErrors[name]; // Remove the error for the specific question using its name
                                          return newErrors; // Return the updated errors object
                                        });
                                        setImageData((prevData) => {
                                          const newData = { ...prevData };
                                          newData[question.label] = value.label;
                                          return newData;
                                        });
                                      }}
                                      options={locationOption}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label=""
                                          fullWidth
                                          variant="outlined"
                                          size="small"
                                          name={question.id}
                                          id={question.id}
                                          placeholder="Please, Enter location"
                                          error={!!errors[question.id]}
                                        />
                                      )}
                                    />
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                  </>
                                )}

                                {question.type === "Media" && (
                                  <>
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      startIcon={<PhotoCamera />}
                                      sx={{
                                        mt: 1,

                                        color: "#036185",
                                        width: "100% ",
                                      }}
                                    >
                                      Upload Images
                                      <input
                                        type="file"
                                        accept="image/*"
                                        hidden
                                        name={question.id}
                                        id={question.id}
                                        multiple // Allow multiple files
                                        onChange={(e) => {
                                          const files = e.target.files;
                                          if (Array.from(files)?.length > 0) {
                                            setErrors((prevErrors) => {
                                              const newErrors = {
                                                ...prevErrors,
                                              }; // Create a copy of the previous errors state
                                              delete newErrors[question.id]; // Remove the error for the specific question using its name
                                              return newErrors; // Return the updated errors object
                                            });
                                          }
                                          const imageList = Array.from(
                                            files
                                          ).map((file) => {
                                            const reader = new FileReader();
                                            return new Promise((resolve) => {
                                              reader.onloadend = () => {
                                                resolve({
                                                  base64: reader.result,
                                                  extension:
                                                    file.type.split("/")[1], // Get the file extension
                                                });
                                              };
                                              reader.readAsDataURL(file);
                                            });
                                          });

                                          Promise.all(imageList).then(
                                            (images) => {
                                              setImageData((prevData) => {
                                                const newData = { ...prevData };
                                                newData[question.label] =
                                                  images;
                                                return newData;
                                              });
                                            }
                                          );
                                        }}
                                      />
                                    </Button>
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                    {imageData[question.label] &&
                                      imageData[question.label].length > 0 && (
                                        <Box
                                          sx={{
                                            mt: 2,
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: 2,
                                          }}
                                        >
                                          <Grid container spacing={2}>
                                            {imageData[question.label].map(
                                              (image, index) => (
                                                <Grid item xs={2} key={index}>
                                                  <Box
                                                    key={index}
                                                    sx={{
                                                      position: "relative",
                                                      borderRadius: "8px",
                                                      overflow: "hidden",
                                                    }}
                                                  >
                                                    <img
                                                      src={image.base64}
                                                      alt={`Preview ${
                                                        index + 1
                                                      }`}
                                                      style={{
                                                        width: "100%", // Set the desired width
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: "8px",
                                                      }}
                                                    />
                                                    {/* Optional: Add a delete button for individual images */}
                                                    <IconButton
                                                      size="small"
                                                      onClick={() => {
                                                        const updatedImages =
                                                          imageData[
                                                            question.label
                                                          ].filter(
                                                            (_, i) =>
                                                              i !== index
                                                          );
                                                        setImageData(
                                                          (prevData) => {
                                                            const newData = {
                                                              ...prevData,
                                                            };
                                                            newData[
                                                              question.label
                                                            ] = updatedImages; // Update images after deletion
                                                            return newData;
                                                          }
                                                        );
                                                      }}
                                                      sx={{
                                                        position: "absolute",
                                                        top: 0,
                                                        right: 0,
                                                        backgroundColor:
                                                          "rgba(0, 0, 0, 0.5)",
                                                        color: "white",
                                                        "&:hover": {
                                                          backgroundColor:
                                                            "rgba(0, 0, 0, 0.8)",
                                                        },
                                                      }}
                                                    >
                                                      <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                  </Box>
                                                </Grid>
                                              )
                                            )}
                                          </Grid>
                                        </Box>
                                      )}
                                  </>
                                )}
                                {question.type === "Video" && (
                                  <>
                                    <Button
                                      variant="outlined"
                                      component="label"
                                      startIcon={<PhotoCamera />}
                                      sx={{
                                        mt: 1,

                                        color: "#036185",
                                        width: "100%",
                                      }}
                                    >
                                      Upload Videos
                                      <input
                                        type="file"
                                        accept="video/*"
                                        hidden
                                        name={question.id}
                                        id={question.id}
                                        multiple // Allow multiple videos
                                        onChange={(e) => {
                                          const files = e.target.files;
                                          const MAX_SIZE_MB = 20;
                                          const MAX_SIZE_BYTES =
                                            MAX_SIZE_MB * 1024 * 1024;

                                          const validFiles = Array.from(
                                            files
                                          ).filter(
                                            (file) =>
                                              file.size <= MAX_SIZE_BYTES
                                          );
                                          const invalidFiles = Array.from(
                                            files
                                          ).filter(
                                            (file) => file.size > MAX_SIZE_BYTES
                                          );

                                          if (invalidFiles.length > 0) {
                                            setErrors((prevErrors) => ({
                                              ...prevErrors,
                                              [question.id]: `Some files are too large. Maximum size allowed is ${MAX_SIZE_MB}MB.`,
                                            }));
                                          } else {
                                            setErrors((prevErrors) => {
                                              const newErrors = {
                                                ...prevErrors,
                                              };
                                              delete newErrors[question.id];
                                              return newErrors;
                                            });
                                          }

                                          if (validFiles.length > 0) {
                                            const videoList = validFiles.map(
                                              (file) => {
                                                const reader = new FileReader();
                                                return new Promise(
                                                  (resolve) => {
                                                    reader.onloadend = () => {
                                                      resolve({
                                                        base64: reader.result,
                                                        extension:
                                                          file.type.split(
                                                            "/"
                                                          )[1], // Get the file extension
                                                      });
                                                    };
                                                    reader.readAsDataURL(file);
                                                  }
                                                );
                                              }
                                            );

                                            Promise.all(videoList).then(
                                              (videos) => {
                                                setImageData((prevData) => {
                                                  const newData = {
                                                    ...prevData,
                                                  };
                                                  newData[question.label] =
                                                    videos;
                                                  return newData;
                                                });
                                              }
                                            );
                                          }
                                        }}
                                      />
                                    </Button>
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                    {imageData[question.label] &&
                                      imageData[question.label].length > 0 && (
                                        <Box
                                          sx={{
                                            mt: 2,
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: 2,
                                          }}
                                        >
                                          <Grid container spacing={2}>
                                            {imageData[question.label].map(
                                              (video, index) => (
                                                <Grid item xs={4} key={index}>
                                                  <Box
                                                    key={index}
                                                    sx={{
                                                      position: "relative",
                                                      borderRadius: "8px",
                                                      overflow: "hidden",
                                                    }}
                                                  >
                                                    <video
                                                      src={video.base64}
                                                      controls
                                                      style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: "8px",
                                                      }}
                                                    />
                                                    <IconButton
                                                      size="small"
                                                      onClick={() => {
                                                        const updatedVideos =
                                                          imageData[
                                                            question.label
                                                          ].filter(
                                                            (_, i) =>
                                                              i !== index
                                                          );
                                                        setImageData(
                                                          (prevData) => {
                                                            const newData = {
                                                              ...prevData,
                                                            };
                                                            newData[
                                                              question.label
                                                            ] = updatedVideos; // Update videos after deletion
                                                            return newData;
                                                          }
                                                        );
                                                      }}
                                                      sx={{
                                                        position: "absolute",
                                                        top: 0,
                                                        right: 0,
                                                        backgroundColor:
                                                          "rgba(0, 0, 0, 0.5)",
                                                        color: "white",
                                                        "&:hover": {
                                                          backgroundColor:
                                                            "rgba(0, 0, 0, 0.8)",
                                                        },
                                                      }}
                                                    >
                                                      <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                  </Box>
                                                </Grid>
                                              )
                                            )}
                                          </Grid>
                                        </Box>
                                      )}
                                  </>
                                )}

                                {question.type === "Radio Buttons" && (
                                  <>
                                    <FormControl
                                      component="fieldset"
                                      fullWidth
                                      required={question.required}
                                    >
                                      <RadioGroup
                                        name={`${question.id}`}
                                        id={question.id}
                                        sx={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                        value={
                                          imageData[question.label] ||
                                          question.options[0]
                                        }
                                        defaultValue={question.options[0]}
                                        onChange={(e) => {
                                          setImageData((prevData) => {
                                            const newData = { ...prevData };
                                            newData[question.label] =
                                              e.target.value;
                                            return newData;
                                          });
                                        }}
                                      >
                                        {question.options.map(
                                          (option, index) => (
                                            <FormControlLabel
                                              key={index}
                                              value={option}
                                              control={<Radio />}
                                              label={option}
                                            />
                                          )
                                        )}
                                      </RadioGroup>
                                    </FormControl>
                                  </>
                                )}

                                {question.type === "Service Unit" && (
                                  <>
                                    <Select
                                      options={serviceUnitOptions}
                                      value={serviceUnit}
                                      menuPortalTarget={document.body}
                                      onChange={(e) => {
                                        setServiceUnit(e);

                                        setErrors((prevErrors) => {
                                          const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                          delete newErrors[`${question.id}`]; // Remove the error for the specific question using its name
                                          return newErrors; // Return the updated errors object
                                        });
                                        setImageData((prevData) => {
                                          const newData = { ...prevData };
                                          newData[question.label] = e;
                                          return newData;
                                        });
                                      }}
                                      name={`${question.id}`}
                                      id={question.id}
                                      styles={customStyles}
                                      placeholder="Select Type"
                                    />
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                  </>
                                )}

                                {question.type === "Project" && (
                                  <>
                                    <Select
                                      options={projectOptions}
                                      value={project}
                                      menuPortalTarget={document.body}
                                      onChange={(e) => {
                                        setProject(e);
                                        setErrors((prevErrors) => {
                                          const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                          delete newErrors[`${question.id}`]; // Remove the error for the specific question using its name
                                          return newErrors; // Return the updated errors object
                                        });
                                        setImageData((prevData) => {
                                          const newData = { ...prevData };
                                          newData[question.label] = e;
                                          return newData;
                                        });
                                      }}
                                      name={`${question.id}`}
                                      id={question.id}
                                      styles={customStyles}
                                      className={
                                        !projectOptions ? "form-disabled" : ""
                                      }
                                      placeholder="Select Project"
                                    />
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                  </>
                                )}

                                {question.type === "Users" && (
                                  <>
                                    <Select
                                      isMulti
                                      options={users}
                                      value={selectedUsers}
                                      menuPortalTarget={document.body}
                                      onChange={(e) => {
                                        setSelectedUsers(e);
                                        setErrors((prevErrors) => {
                                          const newErrors = { ...prevErrors }; // Create a copy of the previous errors state
                                          delete newErrors[`${question.id}`]; // Remove the error for the specific question using its name
                                          return newErrors; // Return the updated errors object
                                        });
                                        setImageData((prevData) => {
                                          const newData = { ...prevData };
                                          newData[question.label] = e;
                                          return newData;
                                        });
                                      }}
                                      name={`${question.id}`}
                                      id={question.id}
                                      styles={customStyles}
                                      placeholder="Select Users"
                                    />
                                    {errors[question.id] && (
                                      <div className="form-error-message">
                                        {errors[question.id]}
                                      </div>
                                    )}
                                  </>
                                )}

                                {(question.type === "Media" ||
                                  question.type === "Video" ||
                                  question.type === "Radio Buttons" ||
                                  question.type === "CheckBox") && (
                                  <>
                                    {!(
                                      notes[question.id] ||
                                      notes[question.id] === ""
                                    ) && (
                                      <Button
                                        startIcon={<AddCircleOutline />}
                                        sx={{
                                          display: "flex",

                                          marginLeft: "auto",
                                        }}
                                        onClick={() => {
                                          setNotes((prevData) => {
                                            const newData = { ...prevData };

                                            // Use question.id as the key and set the value to the new value
                                            newData[question.id] = "";

                                            return newData;
                                          });
                                        }}
                                      >
                                        Add Note
                                      </Button>
                                    )}
                                  </>
                                )}
                                {(notes[question.id] ||
                                  notes[question.id] === "") && (
                                  <Box sx={{ mt: 2, position: "relative" }}>
                                    <TextField
                                      fullWidth
                                      label="Your Notes"
                                      multiline
                                      rows={3}
                                      variant="outlined"
                                      value={notes[question.id] || ""}
                                      onChange={(e) => {
                                        const value = e.target.value;

                                        // Update the notes in the state
                                        setNotes((prevData) => {
                                          const newData = { ...prevData };

                                          // Use question.id as the key and set the value to the new value
                                          newData[question.id] = value;

                                          return newData;
                                        });
                                      }}
                                      name="notes"
                                      placeholder="Add your notes here..."
                                    />

                                    <IconButton
                                      onClick={() => {
                                        setNotes((prevData) => {
                                          const newData = { ...prevData };

                                          delete newData[question.id];

                                          return newData;
                                        });
                                      }}
                                      sx={{
                                        position: "absolute",
                                        top: "0px",
                                        right: "0px",
                                        fontSize: "1.1rem",
                                      }}
                                    >
                                      <CancelIcon sx={{ fontSize: "1.1rem" }} />
                                    </IconButton>
                                  </Box>
                                )}
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  ))}
              </form>

              {(formType === "inspection" || formType === "audit") && (
                <Grid container spacing={2} sx={{ marginTop: "16px" }}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" component="label">
                      Auditor
                      <span style={{ color: "red" }}> *</span>
                    </Typography>
                    <Select
                      options={users}
                      value={selectedUser}
                      onChange={(e) => {
                        setSelectedUser(e);
                        setErrors((prevErrors) => {
                          const newErrors = { ...prevErrors };
                          delete newErrors["user"];
                          return newErrors;
                        });
                      }}
                      menuPortalTarget={document.body}
                      styles={customStyles}
                      placeholder="Select Auditor"
                    />
                    {errors["user"] && (
                      <div className="form-error-message">{errors["user"]}</div>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body1" component="label">
                      Signature
                      <span style={{ color: "red" }}> *</span>
                    </Typography>

                    <Box
                      sx={{
                        borderRadius: "8px",
                        width: "100%",
                        height: "200px",
                      }}
                    >
                      <SignatureCanvas
                        ref={signaturePadRef}
                        penColor="black"
                        canvasProps={{
                          className: "signatureCanvas",
                        }}
                        onBegin={() => {
                          setErrors((prevErrors) => {
                            const newErrors = { ...prevErrors };
                            delete newErrors["signature"];
                            return newErrors;
                          });
                        }}
                      />
                    </Box>

                    {errors["signature"] && (
                      <div className="form-error-message">
                        {errors["signature"]}
                      </div>
                    )}
                  </Grid>

                  <Grid item xs={12}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "8px",
                      }}
                    >
                      <Button
                        variant="outlined"
                        onClick={handleClearSignature}
                        component="label"
                        sx={{
                          color: "#036185",
                        }}
                      >
                        Clear
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Box className="modal-footers">
            <Stack spacing={2} direction="row">
              <Button
                variant="contained"
                className="primary-button"
                disabled={loading}
                onClick={(e) => {
                  handleSubmit(e);
                }}
              >
                {loading && (
                  <CircularProgress
                    size="1rem"
                    sx={{ mr: 1, zIndex: 1, position: "absolute" }}
                  />
                )}
                Save
              </Button>

              <Button
                variant="outlined"
                className="secondary-button"
                disabled={loading}
                onClick={handleCloseDrawer}
              >
                Cancel
              </Button>
            </Stack>
          </Box>
        </DialogActions>
      </CustomizedDialog>

      <CustomizedDialog
        className="modal-scroll"
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        title={"User Status"}
        open={openEmailModal}
        handleClose={() => setOpenEmailModal(false)}
      >
        <DialogContent>
          <Box sx={{ mt: 2, mb: 2 }}>
            <Paper
              sx={{
                overflowX: "auto",
                whiteSpace: "pre-wrap",
                boxShadow: "none",
              }}
            >
              User with Email
              <b> {userData?.email}</b> is Inactive. Do You want to mark as{" "}
              <b>Active</b>?
            </Paper>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box
            className="modal-footers"
            sx={{
              display: "flex",
              flexDirection: "row",
              cursor: "pointer",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <Button
              sx={{ marginRight: "15px" }}
              variant="contained"
              className="primary-button"
              disabled={loading}
              onClick={ChangeUserStatus}
            >
              Confirm
            </Button>
            <Button
              variant="outlined"
              className="secondary-button"
              disabled={loading}
              onClick={() => setOpenEmailModal(false)}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </CustomizedDialog>
    </>
  );
}
